// const getToken = async () => {
//   return "";
// };

export default async (url, args) => {
  // get authorization token
  // const token = await getToken();

  return window
    .fetch(url, {
      headers: new Headers({
        "content-type": "application/json",
        // authorization: token,
      }),
      body: JSON.stringify(args.body),
      method: args.method || "GET",
    })
    .then((response) => {
      return response.json().then((result) => {
        return result;
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
